import { Checkbox as DSCheckbox } from '@designsystem/stories/02-atoms/Checkbox';

export interface CheckboxProps {
  /**
   * The ID of the checkbox.
   */
  id?: string;
  /**
   * The name of the checkbox.
   */
  name?: string;
  /**
   * The value of the checkbox.
   */
  value?: string | boolean;
  /**
   * The label of the checkbox.
   */
  label?: string;
  /**
   * Whether the checkbox is disabled.
   */
  isDisabled?: boolean;
  /**
   * Whether the checkbox is invalid.
   */
  isInvalid?: boolean;
  /**
   * The onChange handler.
   */
  onChange?: (checked: boolean) => void;
  /**
   * The onClick handler.
   */
  onClick?: () => void;
  /**
   * The children of the checkbox.
   */
  children?: React.ReactNode;
}

const Checkbox = ({
  isDisabled,
  isInvalid,
  value,
  ...props
}: CheckboxProps) => {
  return (
    <li>
      <DSCheckbox
        disabled={isDisabled}
        error={isInvalid}
        checked={value}
        {...props}
      />
    </li>
  );
};

export default Checkbox;
